"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestBatch = exports.IkeRestBatchControl = void 0;
const tslib_1 = require("tslib");
const deferred_1 = require("./deferred");
const delayed_task_1 = require("./delayed.task");
class IkeRestBatchControl {
    constructor(boundDepartment) {
        this.boundDepartment = boundDepartment;
        this.batches = {};
    }
    batch(obj, key, value) {
        const batchKey = `${obj.actionName}:${key}`;
        let batch = this.batches[batchKey];
        if (batch == null || batch.executed) {
            this.batches[batchKey] = batch = new IkeRestBatch(this.boundDepartment.query(obj), key);
        }
        return batch.add(value);
    }
}
exports.IkeRestBatchControl = IkeRestBatchControl;
class IkeRestBatch {
    constructor(query, key) {
        this.runner = new delayed_task_1.IkeDelayedTask(() => this.execute(), IkeRestBatch.BATCH_DELAY);
        this.query = query;
        this.key = key;
        this.values = {};
    }
    add(value) {
        let existing = this.values[value];
        if (existing == null) {
            if (this.executed) {
                throw new Error('Cannot add to a executed batch');
            }
            existing = this.values[value] = deferred_1.Deferred.create();
        }
        this.runner.delay();
        return existing.promise;
    }
    execute() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.executed = true;
            const toFetch = Object.keys(this.values);
            var queryBatch = [];
            do {
                queryBatch.push(toFetch.splice(0, IkeRestBatch.BATCH_SIZE));
            } while (toFetch.length > 0);
            for (const batch of queryBatch) {
                this.query.in(this.key, batch);
                this.query.limit(batch.length);
                try {
                    const documents = yield this.query.find();
                    this.resolveDocuments(batch, documents);
                }
                catch (e) {
                    batch.map((id) => this.values[id].reject(e));
                }
            }
        });
    }
    resolveDocuments(batch, documents) {
        const docMap = {};
        for (const document of documents) {
            const key = document[this.key];
            const deffered = this.values[key];
            docMap[key] = true;
            if (deffered != null) {
                deffered.resolve(document);
            }
        }
        if (batch.length === documents.length) {
            return;
        }
        // Resolve null for invalid records
        for (const key of batch) {
            if (docMap[key]) {
                continue;
            }
            const deffered = this.values[key];
            deffered.resolve(null);
        }
    }
}
exports.IkeRestBatch = IkeRestBatch;
IkeRestBatch.BATCH_SIZE = 1000;
IkeRestBatch.BATCH_DELAY = 5;
//# sourceMappingURL=batch.js.map